<template>
  <b-container class="site-page book-container">
    <form-wizard title subtitle ref="wizard" color="#d00000" shape="tab">
      <tab-content title="Location" icon="fa fa-map-marker">
        <section id="locations">
          <h2 class="text-center mb-4">
            Where are you getting your cut?
          </h2>
          <button
            key="finglas"
            class="booking-option text-center"
            @click="onStoreClick('finglas')"
          >
            Finglas Village
          </button>
          <button
            key="ifsc"
            class="booking-option text-center"
            @click="onStoreClick('ifsc')"
          >
            IFSC
          </button>
        </section>
      </tab-content>
    </form-wizard>
  </b-container>
</template>
<script>
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';

export default {
  components: {
    FormWizard,
    TabContent
  },
  methods: {
    onStoreClick(storeId) {
      window.location = `https://book.smartbooks365.com/shops/boxx-${storeId}`;
    }
  }
};
</script>
